import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";
export default {
    methods: {
        async getCustomerAdressesByCustomerId(customerId) {
            var meta = { clientApiMethod: 'getCustomerAdressesByCustomerId', input: { customerId: customerId } }
            var response = await client().get(store.state.apiRouteRoot + "customer/" + customerId + "/address", { meta: meta })
            response?.data.map((element) => {
                element.MetaString = "" +
                    element.Id + " " +
                    element.Name + " " +
                    element.Street + " " +
                    element.Zip + " " +
                    element.City + " " +
                    element.Country;
            })
            return response?.data;
        },
        async getCustomerAdressById(ids) {
            var meta = { clientApiMethod: 'getCustomerAdressById', input: { ids } }
            var response = await client().get(store.state.apiRouteRoot + "customer/" + ids.customerId + "/getsingleaddress/" + ids.addressId, { meta: meta })
            return response?.data;
        },
        async createCustomerAdress(address) {
            address = {
                Id: null,
                CustomerId: address.CustomerId,
                Name: address.Address.Name,
                Street: address.Address.Street,
                Zip: address.Address.Zip,
                City: address.Address.City,
                Country: address.Address.Country
            }
            var meta = {
                clientApiMethod: 'createCustomerAdress',
                input: { address },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.address.address") })
            }
            var response = await client().post(store.state.apiRouteRoot + "customer/" + address.CustomerId + "/address", address, { meta: meta })
            return response?.data;
        },
        async changeCustomerAdressById(address) {
            address = {
                Id: address.Id,
                CustomerId: address.CustomerId,
                Name: address.Address.Name,
                Street: address.Address.Street,
                Zip: address.Address.Zip,
                City: address.Address.City,
                Country: address.Address.Country
            }
            var meta = {
                clientApiMethod: 'changeCustomerAdressById',
                input: { address },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.address.address") })
            }
            var response = await client().post(store.state.apiRouteRoot + "customer/" + address.CustomerId + "/address", address, { meta: meta })
            return response?.data;
        },
        async swapCustomerAdress(jobId, adressId, silent) {
            var meta = {
                clientApiMethod: 'swapCustomerAdress',
                input: { jobId: jobId, adressId: adressId },
                successText: silent ? undefined : i18n.t("servicesystem.responses.swapped_object", { okey: i18n.t("servicesystem.common_objects.address.address") })
            }
            var response = await client().patch(store.state.apiRouteRoot + "job/" + jobId + "/swapaddress/" + adressId, null, { meta: meta })
            //console.log("RESPONSE!", response);
            return response?.data;
        },
    }
}